import {useApi} from "../Api";
import {LocationGroupEntityResponse} from "../types/locationGroup";
import {OWLocationGroupEntityRequest, OWLocationGroupEntityResponse} from "../types/owLocationGroup";

// ONE WAY EXTRA LOCATION GROUPS

export const useOWLocationGroupRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/ow-location-groups";

    function getActiveOWLocationGroups(
        legalEntities: string[]
    ): Promise<OWLocationGroupEntityResponse[]> {
        return GET(`${PATH}/get-active-true?legalEntities=${legalEntities}`);
    }

    function putOWLocationGroup(
        owLocationGroupEntityResponse: OWLocationGroupEntityResponse
    ): Promise<LocationGroupEntityResponse> {
        return PUT(`${PATH}`, owLocationGroupEntityResponse);
    }

    function postOWLocationGroup(
        owLocationGroupEntityRequest: OWLocationGroupEntityRequest
    ): Promise<LocationGroupEntityResponse> {
        return POST(`${PATH}`, owLocationGroupEntityRequest);
    }

    function deleteOWLocationGroup(owLocationGroupId: number): Promise<number> {
        return DELETE(`${PATH}?id=${owLocationGroupId}`);
    }

    return {
        getActiveOWLocationGroups,
        putOWLocationGroup,
        postOWLocationGroup,
        deleteOWLocationGroup,
    };
};
